import { render, staticRenderFns } from "./PagesDetail.vue?vue&type=template&id=2d99bcae&lang=html&"
import script from "./PagesDetail.vue?vue&type=script&lang=js&"
export * from "./PagesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports